export default "__VITE_ASSET__CsWkkoE9__"